import React, { useEffect } from "react";
import SignUpByEmail from "../SignUpByEmail";
import { useOperatorContext } from "../../login/OperatorContextProvider";
import useKiponosNavigator from "../../../hooks/useKiponosNavigator";
import "./Land4.css";

const Land4 = () => {
  const {operatorState, isOperatorReady, landed, setLanded} = useOperatorContext();
  const {navToDefaultPage}                                  = useKiponosNavigator();  

  // Effect
  //
  useEffect(()=>{
    if (isOperatorReady() && !landed) {
      navToDefaultPage();
      setLanded(true);
    }
  }, [operatorState, isOperatorReady, navToDefaultPage, landed, setLanded]);


  //  Return
  // 

  return (
    <div className="kiponos-page">
      <header className="kiponos-header">
        <h1>Instant Config Updates</h1>
        <p className="land4-hero">
          No more manual updates. Anything you change on Kiponos instantly affects your server — no restarts, no redeploys.
        </p>
        <p><strong>Real-time Configuration Management for Modern Java & React Apps</strong></p>
      </header>

      <section className="benefits">
        <div className="benefit">
          <h2>⚡ Real-Time Sync</h2>
          <p>Push config changes directly to all your services. Zero downtime. No redeploy. Your server responds immediately.</p>
        </div>
        <div className="benefit">
          <h2>🧠 Smarter Dev Experience</h2>
          <p>No more .env files, YAMLs, or clutter. Manage all config centrally and securely with intuitive web UI or SDK.</p>
        </div>
        <div className="benefit">
          <h2>👩‍💻 Team-Ready by Design</h2>
          <p>Multiple environments, access per team, and real-time collaborative editing out-of-the-box.</p>
        </div>
        <div className="benefit">
          <h2>🔒 Safe & Observable</h2>
          <p>Full audit logs, instant rollback, encrypted transport. Know what changed, when, and by whom.</p>
        </div>
      </section>

      {}
      <section className="cta">
        <h2>Start in 60 Seconds</h2>
        <SignUpByEmail />
      </section>

      <section className="land4-how-it-works">
        <h2>How Kiponos Works</h2>
        <p>
          After signing up, Kiponos sets up your first environment and gives you a ready-to-use config key.
          Just copy it into your Java/React SDK and start sending updates via secure WebSocket connection — no more redeploys or restarts.
        </p>
        <p>
          The system watches for any change you make on the web panel and instantly syncs it to all live apps.
        </p>
        <p>
          <a href="https://www.youtube.com/watch?v=T67yj9Lxg3k" className="learn-more-link">
            ▶ Watch 2-min video demo  
          </a>
        </p>
      </section>

      <footer className="kiponos-footer">
        &copy; 2025 Kiponos.io — Made for teams who care about speed, safety, and simplicity.
      </footer>
    </div>
  );
};

export default Land4;